function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { UI_OPTIONS_KEY, UI_WIDGET_KEY } from "./constants";
import isObject from "./isObject";
/** Get all passed options from ui:options, and ui:<optionName>, returning them in an object with the `ui:`
 * stripped off. Any `globalOptions` will always be returned, unless they are overridden by options in the `uiSchema`.
 *
 * @param [uiSchema={}] - The UI Schema from which to get any `ui:xxx` options
 * @param [globalOptions={}] - The optional Global UI Schema from which to get any fallback `xxx` options
 * @returns - An object containing all the `ui:xxx` options with the `ui:` stripped off along with all `globalOptions`
 */

export default function getUiOptions() {
  var uiSchema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var globalOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(uiSchema).filter(function (key) {
    return key.indexOf('ui:') === 0;
  }).reduce(function (options, key) {
    var value = uiSchema[key];

    if (key === UI_WIDGET_KEY && isObject(value)) {
      console.error('Setting options via ui:widget object is no longer supported, use ui:options instead');
      return options;
    }

    if (key === UI_OPTIONS_KEY && isObject(value)) {
      return _objectSpread(_objectSpread({}, options), value);
    }

    return _objectSpread(_objectSpread({}, options), {}, _defineProperty({}, key.substring(3), value));
  }, _objectSpread({}, globalOptions));
}